<template>
  <div class="c_list_box" v-if="rewardList && rewardList.length > 0">
    <div class="rewars_wrap" v-for="(item, index) in rewardList" :key="index">
      <div class="reward_tip">{{index+1}}.拉新{{item.personNum}}人奖励{{item.rewardGift && item.rewardGift.length}}选1（价值{{item.rewardMoney}}元）：</div>
      <div class="reward_list"><span v-for="(itemChil, indexChil) in item.rewardGift" :key="indexChil">{{itemChil}}x1、</span></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    rewardList: {
      type: Array
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style lang="less" scoped>
.c_list_box{
  width: 610px;
  padding: 16px;
  background: #F9FAFC;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: scroll;
  line-height: 18px;
  .rewars_wrap{
    margin-bottom: 10px;
    .reward_tip{
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #27272A;
    }
    .reward_list{
      padding: 10px 0;
      margin-top: 2px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #64646C;
    }
  }
  .rewars_wrap:last-child{
    margin-bottom: 0;
  }
}
</style>